module.exports = __webpack_public_path__ + "static/mg-e7bdc49624207a3ee36ecdb79aa129f4.png";